import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import LeaderboardScore from '../../leaderboard/score/LeaderboardScore';
import AttractorTimeout from '../../warning/attractorTimeout';

const EndGameTTB = ({ config, gameData, passRefUpward }) => {

    const [scores, setScores] = useState([]);
    const [result, setResult] = useState({});
    const [upPressed, setUpPressed] = useState(false);
    const [rightPressed, setRightPressed] = useState(false);
    const [downPressed, setDownPressed] = useState(false);
    const [leftPressed, setLeftPressed] = useState(false);

    useEffect(() => {
        if (config.game === 'teamSnake') {
            window.addEventListener('keydown', checkKey);

            return () => {
                window.removeEventListener('keydown', checkKey);
            }
        }


    }, [config.game])

    const checkKey = (e) => {

        if (e.key === 'ArrowUp' || e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'ArrowLeft') {
            if (e.key === 'ArrowUp') {
                setUpPressed(true)
            } else if (e.key === 'ArrowRight') {
                setRightPressed(true)
            } else if (e.key === 'ArrowDown') {
                setDownPressed(true)
            } else if (e.key === 'ArrowLeft') {
                setLeftPressed(true)
            }
        }

    }

    useEffect(() => {
        const result = {
            score: parseInt(window.sessionStorage.getItem('score')),
            date: Date.now()
        }

        const storedScores = JSON.parse(sessionStorage.getItem("storedScores") || "[]");
        result.score && storedScores.push(result);
        sessionStorage.setItem("storedScores", JSON.stringify(storedScores));
        setScores(storedScores);
        setResult(result);
    }, [])

    const storePlayData = () => {
        console.log()
        const playData = {
            score: result.score
        }
        const sessionData = JSON.parse(window.sessionStorage.getItem('sessionData'));
        sessionData.playData.push(playData);
        console.log(sessionData)
        window.sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
    }

    useEffect(() => {
        if (Object.entries(result).length !== 0) {
            storePlayData();
        }
    // eslint-disable-next-line
    }, [result])

    AttractorTimeout(config, passRefUpward);

    return (
        <div className='endGameScore'>
            {upPressed && rightPressed && downPressed && leftPressed &&
                <Redirect push to="/executables/team-snake/attractor" />
            }

            <div className='endGameScore__left'>
                {result.score && (
                    <p className='endGameScore__left-score'>
                        <span>{config.screens.endGameScore.you_scored}</span>
                        <span className='score'>{result.score.toLocaleString()}</span>
                    </p>
                )}
                <div className='endGameScore__left-block'>
                    <span>
                        <img src={`img/game_icons/${gameData.screens.leaderboardScreen.icon}.svg`} alt='' />
                    </span>
                    <h1>{config.screens.endGameScore.block_title}</h1>
                    <p>{config.screens.endGameScore.block_text}</p>
                </div>

                {config.game === 'teamSnake' &&
                    <div className="start-button">
                        <div className="text">
                            {config.screens.endGameScore.play_again_button_text}
                        </div>
        
                        <div className="arrows">
                            <img src={leftPressed ? "./img/game_icons/snake/arrow-solid.svg" : "./img/game_icons/snake/arrow-outline.svg" } className="left" alt=''/>
                            <img src={downPressed ? "./img/game_icons/snake/arrow-solid.svg" : "./img/game_icons/snake/arrow-outline.svg" } className="down" alt=''/>
                            <img src={upPressed ? "./img/game_icons/snake/arrow-solid.svg" : "./img/game_icons/snake/arrow-outline.svg" } className="up" alt=''/>
                            <img src={rightPressed ? "./img/game_icons/snake/arrow-solid.svg" : "./img/game_icons/snake/arrow-outline.svg" } className="right" alt=''/>
                        </div>
                    </div>
                }


                {/* <div className='endGameScore__left-button App__button-large-container'>
                    <button>
                        <Link to="/executables/track-the-ball/attractor">{config.screens.endGameScore.button_text}</Link>
                    </button>
                    <span> </span>
                    <span> </span>
                </div> */}
            </div>
            <LeaderboardScore IsEndGameScore scores={scores} currentScore={result} config={config} />
        </div>
    );
};

export default EndGameTTB;
